export const validateCity = (city: string, locale: string): boolean => {
    // Default regex to allow letters, spaces, and periods, with a minimum length of 3
    // let cityRegex = /^[a-zA-Z\s.]{3,}$/;

    // if (locale === 'en-gb') {
    //     // Allow names with uppercase starting letter and optional hyphen/space-separated parts, now including periods
    //     cityRegex = /^(?:[A-Z][a-z.]+(?:[-\s][A-Za-z.]+)*)$/;
    // }

    // if (
    //     locale === 'de-de' ||
    //     locale === 'es-es' ||
    //     locale === 'fr-fr' ||
    //     locale === 'it-it' ||
    //     locale === 'pl-pl' ||
    //     locale === 'en-eu'
    // ) {
    //     // Extended Latin characters + spaces, hyphens, apostrophes, and now periods
    //     cityRegex = /^[A-Za-zÄäÀàÁáÂâÃãÅåǍǎĄąĂăÆæĀāÇçĆćĈĉČčĎđĐďðÈèÉéÊêËëĚěĘęĖėĒēĜĝĢģĞğĤĥÌìÍíÎîÏïıĪīĮįĴĵĶķĹĺĻļŁłĽľĿŀÑñŃńŇňŅņÖöÒòÓóÔôÕõŐőØøŒœŔŕŘřẞßŚśŜŝŞşŠšȘșŤťŢţÞþȚțÜüÙùÚúÛûŰűŨũŲųŮůŪūŴŵÝýŸÿŶŷŹźŽžŻż¡¿·' .-]{2,50}$/;
    // }
    // return cityRegex.test(city.trim());
    return true;
};


// Validate input with a regex for a simple format check
export const validateInput = (inputString: string): boolean => {
    const inputStringRegex = /[*|":<>[\]{}\\();@&?%=$`]/;;
    return !inputStringRegex.test(inputString);
};

export const validateStringOrIntegerAddress = function (input: any, locale: string) {
    var trimmedInput = input.trim();
    if (locale === 'en-gb' || locale === 'es-mx') {
        return true;
    }
    // Check if the input contains only numbers
    if (/^\d+(\s+\d+)*$/.test(trimmedInput)) {
        return false; // Return false if the input contains only numbers
    }

    // Check if the input contains only alphabet letters and spaces without numbers
    if (/^[A-Za-z\s]+$/.test(trimmedInput) && !/\d/.test(trimmedInput)) {
        return false; // Return false if the input contains only letters and spaces
    }

    // Check if the input contains a mix of letters, numbers, and spaces
    if (/^[A-Za-z0-9\s]+$/.test(trimmedInput) && /\d/.test(trimmedInput) && /[A-Za-z]/.test(trimmedInput)) {
        return true; // Return true if the input is valid with letters and numbers
    }
    // If none of the above conditions are met, return true
    return true;
};
export const validateAddress = (input: any) => {
    const invalidKeywords = [
        "P O BOX",
        "PO BOX",
        "POBOX",
        "P. O. BOX",
        "P.O. BOX",
        "P.O.BOX",
        "Parcel Locker",
        "Parcel Collect",
        "Parcel",
        "PO",
        "Locker",
        "Packstation",
        "Pack Station",
        "FPO",
        "P.O BOX",
        "PO. BOX",
        "APO",
        "DPO",
        "Post Ofc Box",
        "Post office box",
        "Post Office",
        "PostOffice",
        "pob",
        "mailbox"
    ];
    // Validate against invalid keywords
    for (const keyword of invalidKeywords) {
        const keywordRegex = new RegExp(`\\b${keyword}\\b`, 'i');
        if (keywordRegex.test(input)) {
            console.log(`Matching keyword: ${keyword}`);
            return false;
        }
    }
    return true;
};
export const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(email);
};
// Validate contact with a regex for a simple format check
export const validateContactNumber = (phone: any) => {
    const contactRegex = /^(\+?\d{1,3}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return contactRegex.test(phone);
}
export const validatePassword = (password: string): boolean => {
    // Password must be between 8 - 32 characters
    if (password.length < 8 || password.length > 32) {
        return false;
    }

    // Password must include at least three of the following:
    // - Upper case letter
    // - Lower case letter
    // - Numbers
    // - Special characters: ! @ # $ % ^ * ~ : ; & > < [ ] { } | - _ + = ?
    const upperCaseRegex = /[A-Z]/;
    const lowerCaseRegex = /[a-z]/;
    const numberRegex = /[0-9]/;
    const specialCharacterRegex = /[!@#$%^*~:;&><[\]{}|_\-+=?]/;

    let complexityCount = 0;
    if (upperCaseRegex.test(password)) {
        complexityCount++;
    }
    if (lowerCaseRegex.test(password)) {
        complexityCount++;
    }
    if (numberRegex.test(password)) {
        complexityCount++;
    }
    if (specialCharacterRegex.test(password)) {
        complexityCount++;
    }

    return complexityCount > 3;
}

export const validatePostalCodes = (postalCode: string, locale: string, country?: string) => {
    let postalCodeRegex = /^[0-9]{5}$/;

    if (locale === 'en-gb') {
        postalCodeRegex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z]{1,2}[0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})|([A-Za-z]{2}[0-9]{1,2})$/;
        if (country === 'BM') {
            postalCodeRegex = /^(?:[A-Z]{2}\s?\d{2})$/;
        }
    } else if (['nb-no', 'es-es', 'fr-fr', 'it-it', 'pl-pl'].includes(locale)) {
        if (country === 'IE') {
            postalCodeRegex = /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/mg;
        } else if (['AT', 'BG', 'BE', 'CY', 'DK', 'HU', 'LU', 'PT', 'NO'].includes(country)) {
            postalCodeRegex = /^\d{4}$/;
        } else if (country === 'CZ') {
            postalCodeRegex = /^\d{3}\s*\d{2}$/;
        } else if (country === 'GR') {
            postalCodeRegex = /^\d{3}\s{0,1}\d{2}$/;
        } else if (country === 'LT') {
            postalCodeRegex = /^[Ll][Tt][- ]{0,1}\d{5}$/;
        } else if (country === 'LV') {
            postalCodeRegex = /^[Ll][Vv][- ]{0,1}\d{4}$/;
        } else if (country === 'MT') {
            postalCodeRegex = /^[A-Za-z]{3}\s{0,1}\d{4}$/;
        } else if (country === 'NL') {
            postalCodeRegex = /^\d{4}\s{0,1}[A-Za-z]{2}$/;
        } else if (country === 'PL') {
            postalCodeRegex = /\d{2}[- ]{0,1}\d{3}$/;
        } else if (country === 'RO') {
            postalCodeRegex = /^\d{6}$/;
        } else if (country === 'SK') {
            postalCodeRegex = /^\d{5}\s\(\d{3}\s\d{2}\)$/;
        } else if (country === 'SI') {
            postalCodeRegex = /^([Ss][Ii][- ]{0,1}){0,1}\d{4}$/;
        } else if (country === 'SE') {
            postalCodeRegex = /^\d{3}\s*\d{2}$/;
        } else if (country === 'PL') {
            postalCodeRegex = /^\d{2}[- ]{0,1}\d{3}$/;
        } else {
            postalCodeRegex = /^\d{5}$/;
        }
    } else if (locale === 'de-de') {
        postalCodeRegex = country === 'LI' ? /^\d{4}$/ : /^\d{5}$/;
    } else if (locale === 'en-af') {
        postalCodeRegex = country === 'TN' ? /^\d{4}$/ : /^\d{5}$/;
    } else if (locale === 'en-us') {
        postalCodeRegex = /^\d{5}(-\d{4})?$/;
    } else if (locale === 'es-la') {
        switch (country) {
            case 'CR': // Costa Rica
                postalCodeRegex = /^\d{5}$/;
                break;
            case 'DO': // Dominican Republic
                postalCodeRegex = /^\d{5}$/;
                break;
            case 'GT': // Guatemala
                postalCodeRegex = /^(0[1-9]|1[0-9]|2[0-2])\d{3}$/;
                break;
            case 'PA': // Panama (optional postal code)
                postalCodeRegex = /^(\d{4})?$/;
                break;
            case 'PR': // Puerto Rico (U.S. ZIP format)
                postalCodeRegex = /^\d{5}(-\d{4})?$/;
                break;
            default:
                postalCodeRegex = null; // or a fallback if needed
        }
    } else if (locale === 'en-ca') {
        postalCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
    } else if (locale === 'ja-jp') {
        postalCodeRegex = /^\d{3}-\d{4}$/;
    } else if (locale === 'en-au') {
        // Australia: 4-digit numeric
        postalCodeRegex = /^\d{4}$/;
    } else if (locale === 'en-sg') {
        // Singapore: 6-digit numeric
        postalCodeRegex = /^\d{6}$/;
    } else if (locale === 'en-eu' || locale === 'ko-kr') {
        return true;
    } else if (locale === 'zh-tw') {
        // Taiwan: 3 or 5 digit postal code
        postalCodeRegex = /^\d{3}(\d{2})?$/;
    } else if (locale === 'pt-br') {
        // Brazil: 5 digits + hyphen + 3 digits (e.g., 12345-678)
        postalCodeRegex = /^\d{5}-\d{3}$/;
    } else if (locale === 'es-mx') {
        // Mexico: 5 digits (e.g., 01234)
        postalCodeRegex = /^\d{5}$/;
    } else if (locale === 'en-ph') {
        // Philippines: 4 digits (e.g., 1234)
        postalCodeRegex = /^\d{4}$/;
    } else if (locale === 'pl-pl') {
        // Poland: postal code format NN-NNN
        postalCodeRegex = /^\d{2}-\d{3}$/;
    } else if (locale === 'nb-no') {
        // Norway: postal code format NN-NNN
        postalCodeRegex = /^\d{4}$/;
    }

    return postalCodeRegex.test(postalCode);
};
